import { Component, Input, OnInit } from '@angular/core';
import { Crons, ProgramConfig, Site } from '@model';

@Component({
  selector: 'bmd-site-configure',
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  styleUrls: ['./site-configure.component.scss'],
  templateUrl: './site-configure.html',
})
export class SiteConfigureComponent implements OnInit {
  @Input() site: Site;
  @Input() crons: Crons;
  @Input() programConfig: ProgramConfig;
  expanded: boolean;

  constructor() {}

  ngOnInit() {
    this.expanded = true;
  }
}
